import chocolate from "../../../images/frontpage/food/chocolate.jpg";
import goldcake from "../../../images/frontpage/food/goldcake.png";
import mangobago from "../../../images/frontpage/food/mangobago.jpg";
import redtea from "../../../images/frontpage/food/redtea.jpg";
// import redtea from "../../../../src/images/food/readtea.jpg";

const hotfooddata = [
    {
        hotfood_sid: 18,
        hotfood_name: "義式巧克力",
        hotfood_price_m: 95,
        hotfood_photo: chocolate,
    },
    {
        hotfood_sid: 29,
        hotfood_name: "金沙焦糖脆脆千層",
        hotfood_price_m: 190,
        hotfood_photo: goldcake,
    },
    {
        hotfood_sid: 19,
        hotfood_name: "愛丁堡女王紅茶",
        hotfood_price_m: 70,
        hotfood_photo: redtea,
    },
    {
        hotfood_sid: 32,
        hotfood_name: "芒果金萱貝果",
        hotfood_price_m: 95,
        hotfood_photo: mangobago,
    },
];

export default hotfooddata;
